import { render, staticRenderFns } from "./SumCustomerScan.vue?vue&type=template&id=0ffdbd0a&scoped=true&"
import script from "./SumCustomerScan.vue?vue&type=script&lang=js&"
export * from "./SumCustomerScan.vue?vue&type=script&lang=js&"
import style0 from "./SumCustomerScan.vue?vue&type=style&index=0&id=0ffdbd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffdbd0a",
  null
  
)

export default component.exports